import { ReactNode } from "react";
import { Box, Button, Stack, StackProps } from "@mui/material";

import { Link } from "react-router-dom";

type FormActionsProps = {
  isLoading: boolean;
  backHref?: string;
  submitText: string;
  backText?: string;
  children?: ReactNode;
} & StackProps;

export const FormActions = ({
  isLoading,
  backHref,
  submitText,
  backText,
  children,
  ...stackProps
}: FormActionsProps) => {
  return (
    <Stack
      direction={"row"}
      {...stackProps}
      sx={[
        {
          gap: 2,
          justifyContent: "flex-end",
          paddingInline: 2,
        },
        ...(Array.isArray(stackProps.sx) ? stackProps.sx : [stackProps.sx]),
      ]}
    >
      {children}
      <Box sx={{ flexGrow: 1 }} />
      {backHref && (
        <Button variant={"outlined"} component={Link} to={backHref}>
          {backText}
        </Button>
      )}
      <Button type={"submit"} loading={isLoading}>
        {submitText}
      </Button>
    </Stack>
  );
};
